<template>
  <v-menu
      left
      bottom
      :close-on-click="false"
      :close-on-content-click="false"
      v-model="picker"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" small outlined rounded color="primary" class="ml-3">
        {{ activePeriod }}
        <v-icon right small>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-date-picker
        scrollable
        locale="ru"
        range
        color="primary"
        :no-title="true"
        v-model="dates"
    >
      <v-spacer/>
      <v-btn text @click="cleanPeriod">
        Сбросить
      </v-btn>
      <v-btn  :disabled="dates.length < 2" text color="primary" @click="savePeriod">
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'SelectDate',
  components: {

  },
  data: () => ({
    picker: false,
    date: new Date().toISOString().substr(0, 10),
    dates: [0, 0]
  }),
  computed: {
    activePeriod() {
      if (!this.dates[0] || !this.dates[1]) {
        return "Любая дата дедлайна";
      }
      return `c ${this.getDate(this.dates[0])} по ${this.getDate(this.dates[1])}`;
    },
  },
  methods: {
    cleanPeriod() {
      this.picker = false;
      this.dates = [0,0];
      this.$emit("change-period", {
        start: 0,
        end: 0
      })
    },
    savePeriod() {
      window.console.log("hello")
      this.picker = false;
      this.$emit("change-period", {
        start: this.dates[0],
        end: this.dates[1]
      });
    },
    getDate(value) {
      const date = new Date(value);
      let month = date.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      let day = date.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      return `${day}-${month}-${date.getFullYear()}`;
    },
  },
  mounted() {

  }
}
</script>